export default __webpack_public_path__ + "logo-insegnia-Italia-cb3e4a71dca727dc61bc0774a70ab57f.svg";